// Per-browser "last used checkout terminal" preference, scoped by business
// location. Mirrors the localStorage helper pattern in CalendarContext.tsx.
// Each physical checkout station (browser) remembers its own terminal so
// parallel lanes don't collide; the value is the Stripe reader device id.

const STORAGE_PREFIX = "pagoda.checkout.terminal.";

const keyFor = (businessLocationId: string): string =>
  `${STORAGE_PREFIX}${businessLocationId}`;

export const getPreferredTerminalDeviceId = (
  businessLocationId: string,
): string | null => {
  if (typeof window === "undefined" || !businessLocationId) return null;
  try {
    return localStorage.getItem(keyFor(businessLocationId));
  } catch {
    return null;
  }
};

export const setPreferredTerminalDeviceId = (
  businessLocationId: string,
  deviceId: string,
): void => {
  if (typeof window === "undefined" || !businessLocationId) return;
  try {
    localStorage.setItem(keyFor(businessLocationId), deviceId);
  } catch {
    /* ignore localStorage errors (private mode, quota) */
  }
};
